import { a as u, D, b as w } from "./DropdownDivider-c57dbbbe.js";
import { resolveComponent as i, resolveDirective as _, openBlock as o, createElementBlock as l, createVNode as h, Transition as v, withCtx as a, withDirectives as y, createBlock as r, normalizeClass as g, normalizeStyle as k, Fragment as b, renderList as z, createCommentVNode as d, withModifiers as C, resolveDynamicComponent as x, createElementVNode as B, toDisplayString as L } from "vue";
import { _ as N } from "./_plugin-vue_export-helper-dad06003.js";
const A = {
  components: {
    DropdownList: u,
    DropdownItem: D,
    DropdownDivider: w
  },
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "sm"
    },
    right: {
      type: Boolean,
      default: !1
    },
    offsetRight: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:open"],
  computed: {
    itemsForDesktop() {
      return this.items.filter((t) => !t.mobileOnly);
    },
    showDropdown: {
      get() {
        return this.open;
      },
      set(t) {
        this.$emit("update:open", t);
      }
    }
  },
  methods: {
    closeAndDo(t) {
      t && t(), this.showDropdown = !1;
    }
  }
}, F = { class: "hidden lg:block" };
function I(t, R, s, S, V, n) {
  const c = i("DropdownDivider"), m = i("DropdownItem"), p = i("DropdownList"), f = _("click-outside");
  return o(), l("div", F, [
    h(v, { name: "fade" }, {
      default: a(() => [
        n.showDropdown ? y((o(), r(p, {
          key: 0,
          class: g(["absolute -bottom-1 z-30 transfrom translate-y-full", [
            s.right ? "right-0" : "left-0",
            {
              "min-w-48": s.size === "sm",
              "min-w-60": s.size === "md",
              "min-w-72": s.size === "lg"
            }
          ]]),
          style: k([
            s.offsetRight ? { right: `${s.offsetRight}px`, transform: "translateY(calc(100% - 12px))" } : {}
          ])
        }, {
          default: a(() => [
            (o(!0), l(b, null, z(n.itemsForDesktop, (e) => (o(), l("div", {
              key: e.label
            }, [
              e.isDivider ? (o(), r(c, { key: 0 })) : d("", !0),
              !e.isDivider && e.label ? (o(), r(m, {
                key: 1,
                value: e.value,
                "is-selected": e.active,
                "is-danger": e.isDanger,
                onClick: C((E) => n.closeAndDo(e.handler), ["stop"])
              }, {
                default: a(() => [
                  (o(), r(x(e.icon))),
                  B("span", null, L(e.label), 1)
                ]),
                _: 2
              }, 1032, ["value", "is-selected", "is-danger", "onClick"])) : d("", !0)
            ]))), 128))
          ]),
          _: 1
        }, 8, ["class", "style"])), [
          [
            f,
            () => {
              n.showDropdown = !1;
            }
          ]
        ]) : d("", !0)
      ]),
      _: 1
    })
  ]);
}
const Y = /* @__PURE__ */ N(A, [["render", I]]);
export {
  Y as D
};
